import { createApp } from "vue";
import App from "./App.vue";
import router from "./routers";

import axios from "axios";
import VueAxios from "vue-axios";

import Vuex from "vuex";
import store from "./store";

createApp(App)
  .use(router)
  .use(Vuex)
  .use(store)
  .use(VueAxios, axios)
  .mount("#app");
